export const CORE_FEATURE_CREATED = 'CORE_FEATURE_CREATED';
export const CORE_FEATURE_DELETED = 'CORE_FEATURE_DELETED';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/core/actions/features.ts